<template>
  <div id="prcSearch">
    <div class="top">
      <h3><svg-icon icon-class="signpost" />产品种类规则（PCR）库</h3>
      <a-button type="primary" size="small" @click="openEvent('/institutionalInformation')">查看标准、计量、检测与认证机构信息<icon-right /></a-button>
    </div>
    <SearchPanel 
      :search="search" 
      :searchData="searchData"
      @search="searchClick"></SearchPanel>
    <CommonListCom :show="show" @clear="clearClick">
      <div class="flex-ac-js">
        <h3>共找到 <span>{{ totalNum }}</span> 份PCR</h3>
        <a-button size="mini" @click="openEvent('https://tgik6tfkz3.jiandaoyun.com/f/69ccd47218452f6c8939e66a')"><svg-icon icon-class="send"></svg-icon>联系平台获取文本</a-button>
      </div>
    </CommonListCom>
    <a-table 
    :loading="loading || false"
    :columns="columns" 
    :data="tableData" 
    :bordered="false"   
    :pagination="false">
      <template #unitNameTitle>
        PCR/标准名称
        <a-tooltip content="PCR 中文名称仅作参考，请以 PCR 原文名称为准">
          <icon-question-circle-fill />
        </a-tooltip>
      </template>
      <template #number="{ record }">
        <span class="table_item">
          <svg-icon :icon-class="CONST.productList.filter(item => { return item.value == record.category })[0].icon" />
          <span>{{ record.number }}</span>
        </span>
      </template>
      <template #title="{ record }">
        <h4>{{ record.chineseName }}</h4>
        <h4 style="font-weight: 400;">{{ record.englishName }}</h4>
      </template>
      <template #status="{ record }">
        <span>{{ CONST.organizationsList.filter(item => { return item.value == record.region })[0].label }}</span>
      </template>
    </a-table>
    <CommonPagination
      :pageNum="pageNum"
      :pageSize="pageSize"
      :totalNum="totalNum"
      placement="right"></CommonPagination>
  </div>
</template>

<script>
import SearchPanel from '../standardInformationBase/components/SearchPanel.vue'
import CommonListCom from '@/components/CommonListCom.vue'
import CommonPagination from '@/components/CommonPagination.vue'
import merge from 'webpack-merge'
import { CONST } from '@/assets/js/CONST'
export default {
  components: {
    SearchPanel,
    CommonListCom,
    CommonPagination
  },
  computed: {
    CONST() { return CONST }
  },
  data() {
    return {
      searchData: {
        keyword: '',
        category: ['ALL'],
        region: ['ALL'],
      },
      search: {
        input: { key: 'keyword', place: '搜索 PCR 编号、中文名称或英文名称' },
        list: [
          { name: '产品类别', list: 'productList', key: 'category' },
          { name: '国家地区组织', list: 'organizationsList', key: 'region' },
        ]
      },
      pageNum: parseInt(this.$route.query.pager) || 1,
      pageSize: 15,
      totalNum: 100,
      columns: [
      { title: 'PCR/标准号', slotName: 'number', width: 308 },
      { title: 'PCR/标准名称', slotName: 'title', titleSlotName: 'unitNameTitle'  },
      { title: '国家/地区/组织',slotName: 'status', align: 'center', width: 150 },
      { title: '发布日期', dataIndex: 'releaseDate', align: 'center', width: 120 },
      { title: '有效日期', dataIndex: 'effectiveDate', align: 'center', width: 120 },
      ],
      tableData: [],
      loading: false,
      show: false
    }
  },
  mounted() {
    this.showPage();
  },
  methods: {
    showPage() {
      // if(this.search) return;
      // else this.search = true
      this.$API.PCRList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyword: this.searchData.keyword,
        category: this.searchData.category[0] == 'ALL' ? '' : this.searchData.category[0],
        region: this.searchData.region[0] == 'ALL' ? '' : this.searchData.region[0],
      }).then(res => {
        if(res.data.code == 200) {
          res.data.data.list.forEach(item => {
            item.effectiveDate = item.effectiveDate && item.effectiveDate.split(' ')[0] || '-';
            item.releaseDate = item.releaseDate && item.releaseDate.split(' ')[0] || '-';
          })
          this.tableData = res.data.data.list;
          this.totalNum = res.data.data.total; 
          // this.search = false;
          window.scrollTo(0, 0)
        }
      })
    },
    searchClick(data) {
      this.searchData[data.key] = data.value;
      this.pageNum = 1;
      this.$router.replace({
        query: merge(this.$route.query, { pager: 1 }),
      });
      this.show = true;
      this.showPage()
    },
    clearClick() {
      this.searchData = {
        keyword: '',
        category: ['ALL'],
        region: ['ALL'],
      };
      this.show = false;
      this.pageNum = 1;
      this.$router.replace({
        query: merge(this.$route.query, { pager: 1 }),
      });
      this.showPage();
    },
    openEvent(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
  #prcSearch {
    width: 1200px;
    margin: 0 auto;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 7px 10px;
      height: 60px;
      margin-bottom: 10px;

      & > h3 {
        font-size: 32px;
        color: #1d2129;
        display: flex;
        align-items: center;

        .svg-icon {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }

      .arco-btn {
        display: flex;
        align-items: center;

        svg {
          font-size: 12px;
          margin-left: 10px;
          opacity: 0.6;
        }
      }
    }

    .search_panel .list  {
      .item {
        padding-bottom: 0;

        & > span {
          width: 90px;
        }
        
        & > div {
          display: flex;
          flex-wrap: wrap;

          .arco-tag {
            margin-bottom: 12px;
            color: #4E5969;
            display: flex;
            align-items: center;

            .svg-icon {
              width: 14px;
              height: 14px;
              color: #4E5969;
              margin-right: 8px;
            }
          }
          .arco-tag-checked {
            color: #fff;

            .svg-icon {
              color: #fff;
            }
          }
        }
      }
      
    }

    .common_list_com .show_num {
      border-bottom: none;
    }

    .flex-ac-js {
      display: flex;
      align-items: center;

      .arco-btn {
        margin-left: 20px;
        background: #f2faf9;
        border-radius: 4px;
        color: #05a081;
        line-height: 20px;
        padding: 0 16px;
        display: flex;
        align-items: center;

        .svg-icon {
          width: 14px;
          height: 14px;
          margin-right: 8px;
        }
      }
    }

    .arco-table {
      padding: 0 10px;
    }

    .arco-table .arco-table-cell {
      padding: 10px;
      color: #86909C;

      h4 {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 4px;
        color: #1D2129;

        &:first-child {
          margin-top: 4px;
        }
      }

      .table_item {
        display: flex;
        align-items: center;
        color: #1D2129;

        .svg-icon {
          width: 14px;
          height: 14px;
          color: #1D2129;
          margin-right: 12px;
        }
      }
    }

    .arco-table-th {
      color: #4E5969;

      .arco-icon {
        font-size: 14px;
        color: #C9CDD4;
      }

      &:first-child {
        .arco-table-cell {
          padding-left: 36px;
        }
      }
    }
  }
</style>